import { usePlayerStore } from '@/store/playerStore';
import { Sparkles, Pause, Play } from 'lucide-react';
import { clsx } from 'clsx';
import type { SmartTuneState } from '@/types/domain';

export function SmartTuneControl() {
  const state = usePlayerStore((s) => s.smartTune);
  const setSmartTune = usePlayerStore((s) => s.setSmartTune);

  const cycle: SmartTuneState =
    state === 'disabled' ? 'enabled' : state === 'enabled' ? 'paused' : 'disabled';

  const label =
    state === 'disabled'
      ? 'Smart Tune: Kapalı'
      : state === 'enabled'
        ? 'Smart Tune: Açık'
        : 'Smart Tune: Duraklatıldı';

  return (
    <button
      type="button"
      onClick={() => setSmartTune(cycle)}
      aria-label={label}
      title={label}
      className={clsx(
        'flex items-center gap-1.5 rounded-lg px-2.5 py-2 text-xs font-medium transition-colors',
        state === 'enabled'
          ? 'bg-accent-500/20 text-accent-200'
          : state === 'paused'
            ? 'bg-orange-500/15 text-orange-300'
            : 'bg-white/5 text-slate-400 hover:text-slate-200',
      )}
    >
      {state === 'paused' ? (
        <Pause className="h-3.5 w-3.5" />
      ) : (
        <Sparkles className="h-3.5 w-3.5" />
      )}
      <span className="hidden xl:inline">Smart Tune</span>
      {state === 'enabled' && <Play className="h-3 w-3" />}
    </button>
  );
}
